interface IPaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

const Pagination = (props: IPaginationProps) => {
  const totalPages = Math.ceil(props.totalItems / props.itemsPerPage);
  const isFirstPage = props.currentPage === 1;
  const isLastPage = props.currentPage >= totalPages;

  if (props.totalItems === 0) {
    return null;
  }

  return (
    <div className="flex justify-center items-center gap-2 mt-6">
      <button
        className="px-3 py-1 text-size-16 bg-white dark:bg-neutral-900 text-gray-500 dark:text-neutral-400 hover:bg-gray-50 dark:hover:bg-neutral-800 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-neutral-900"
        onClick={() => props.onPageChange(props.currentPage - 1)}
        disabled={isFirstPage}
      >
        <span className="rioglyph rioglyph-chevron-left text-gray-300 dark:text-neutral-600"></span>
      </button>
      <div className="ml-2 mr-2 px-4 py-1 text-size-16 bg-gray-400 dark:bg-neutral-600 text-gray-100 font-bold cursor-default">
        {props.currentPage}
      </div>
      <button
        className="px-3 py-1 text-size-16 bg-white dark:bg-neutral-900 text-gray-500 dark:text-neutral-400 hover:bg-gray-50 dark:hover:bg-neutral-800 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-neutral-900"
        onClick={() => props.onPageChange(props.currentPage + 1)}
        disabled={isLastPage}
      >
        <span className="rioglyph rioglyph-chevron-right text-gray-300 dark:text-neutral-600"></span>
      </button>
    </div>
  );
};

export default Pagination;

